import {http} from '../core/http';
import type {
  CreateFolderParams,
  DeleteFolderParams,
  FileQueryParams,
  FileQueryResponse, FileType,
  MoveFolderParams,
  PermissionCheckParams,
  RenameParams
} from '../types/directory';

export const directoryService = {
  getDirectory(params: FileQueryParams): Promise<FileQueryResponse> {
    return http.post('/uss/get_directory', params);
  },

  getNavigationDirectory() {
    return http.post('/uss/get_main_directory', {});
  },

  create(params: CreateFolderParams) {
    return http.post('/uss/create_directory', params);
  },

  delete(params: { item: DeleteFolderParams[] }) {
    return http.post('/uss/delete_item', params);
  },

  move(params: MoveFolderParams[]) {
    return http.post('/uss/move_item', params);
  },

  rename(params: RenameParams) {
    return http.post('/uss/rename_item', params);
  },

  checkPermission(params: { items: PermissionCheckParams[] }) {
    return http.post('/uss/batch_get_visibility', params);
  },

  shareItem(params: {
    item_type: FileType;
    item_id: number | string;
    target_directory_ids: Array<number | string>
  }) {
    return http.post('/uss/share_item', params);
  },

  updateShareTargets(params: {
    share_id: number | string;
    target_directory_ids: Array<number | string>
  }) {
    return http.post('/uss/update_share_targets', params);
  },

  unshareItem(params: {
    share_id: number | string;
  }) {
    return http.post('/uss/unshare_item', params);
  },

  updateSharedStatus(params: { status: 0 | 1 }) {
    return http.post('/uss/update_shared_status', params);
  }
};